import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export default function TopNav() {
  return (
    <nav className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center">
            <img src="/ap-logo.png" alt="Automation Prime" className="h-14 w-auto object-contain" />
          </Link>
          
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/about" data-testid="top-nav-about-link" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">About Us</Link>
            <Link to="/portfolio" data-testid="top-nav-portfolio-link" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Portfolio</Link>
            <Link to="/business-builder" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Business Builder</Link>
            <Link to="/simplified" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Simplified</Link>
            <Link to="/we-want-you" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">We Want You</Link>
            <Link to="/investment-opportunities" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Invest</Link>
            <Link to="/contact" data-testid="top-nav-contact-link">
              <Button data-testid="top-nav-primary-cta-button" size="sm" className="rounded-xl shadow-sm hover:shadow-md transition-shadow">Contact</Button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}